import './style.css';
import React from "react";
import NabarAccount from "../Navbar/NabarAccount";
import {isMobile} from "react-device-detect";
import AccountPage from "../../pages/AccountPage";

const AccountSetting = () => {

    return (
        <div className='animate-fadeIn md:pt-8'>
            <div className='relative pb-20'>
                {isMobile ? <NabarAccount/> : <AccountPage/>}
            </div>
        </div>
    )
};

export default AccountSetting;
